module.exports = __webpack_public_path__ + "static/img_0813-219314a051e144a9ad16fad2f4146863.webp";